const ShareLinks = {
  facebook(data) {
    return encodeURI([
      'https://www.facebook.com/sharer/sharer.php',
      `?u=${data.url}`
    ].join(''));
  },

  twitter(data) {
    return encodeURI([
      'https://twitter.com/intent/tweet',
      `?text=${data.text || ''}`,
      `&url=${data.url}`,
      data.hashtags ? `&hashtags=${data.hashtags}` : ''
    ].join(''));
  },

  googlePlus(data) {
    return encodeURI([
      'https://plus.google.com/share',
      `?url=${data.url}`
    ].join(''));
  },

  email(data) {
    return encodeURI([
      'mailto:',
      `?subject=${data.text}`,
      `&body=${data.url}`
    ].join(''));
  },

  getAll(data) {
    return {
      facebook: ShareLinks.facebook(data),
      twitter: ShareLinks.twitter(data),
      googlePlus: ShareLinks.googlePlus(data),
      email: ShareLinks.email(data)
    };
  }
};

export default ShareLinks;



// WEBPACK FOOTER //
// ./src/assets/javascripts/share-link.js